export default "__VITE_ASSET__Dq293H4Y__"